<div id="ht">
    <div id="main-cnt">

        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content">
                        <!-- edit da qui... -->
                                <ion-label position="floating">Password vecchia</ion-label>
                                <ion-input placeholder="Password vecchia" class="text-input"
                                           [(ngModel)]="oldPassword"
                                           type="password"></ion-input>

                                <ion-label position="floating">Nuova password</ion-label>
                                <ion-input placeholder="Nuova password" class="text-input" [(ngModel)]="password"
                                           type="password"></ion-input>

                                <ion-label position="floating">Conferma nuova password</ion-label>
                                <ion-input placeholder="Conferma password" class="text-input"
                                           [(ngModel)]="newPassword"
                                           type="password"></ion-input>

                                <br>




                        <button expand="block" (click)="chacngePassword()"
                                class="button glass-blurred-background drop-shadow padding">Salva
                        </button>

                        <!-- ...a qui -->
                    </div>
                </div>
            </div>
        </ion-content>

    </div>
</div>